<template>
  <div>
    <b-list-group-item>
      <b-row>
        <b-col md="2">{{ activity.ProductionStatusID }}</b-col>
        <b-col md="3">{{ activity.StatusCode }}</b-col>
        <b-col md="3">{{ activity.EventTime }}</b-col>
        <b-col md="3">{{ activity.TrackingNumber }}</b-col>
      </b-row>
    </b-list-group-item>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      //public_activity: this.activity
    };
  },
  components: {},
  props: {
    activity: Object
  },
  methods: {}
};
</script>

<style scoped>
.location-card {
  padding: 20px;
  margin-bottom: 24px;
  transition: all 0.2s linear;
  cursor: pointer;
}
.location-card:hover {
  transform: scale(1.01);
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2), 0 1px 15px 0 rgba(0, 0, 0, 0.19);
}
.location-card > .title {
  margin: 0;
}

.location-link {
  color: black;
  text-decoration: none;
  font-weight: 100;
}
</style>